<template>
    <div>
        <div
            class="rubric-feedback"
            v-for="result of resultsIn"
            :key="result.id">
            <label>Feedback: {{ result.user.full_name }}</label>
            <b-textarea
                class="apprentice-textarea"
                disabled
                :value="result.feedback"
                :placeholder="$t('rubrics.give_feedback')"
                rows="4"
                max-rows="4">
            </b-textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-form-feedback-peer-component',
    props: {
        resultsIn: Array,
    },
};
</script>

<style scoped lang="scss"></style>
